import fileToBase64 from './to-base64'

/**
 * Payload shape expected by `active_storage_base64` on the API.
 * The `data` field must be a full data URI — bare base64 triggers `missing keyword: :io`.
 */
export const buildActiveStorageFilePayload = async (file: File) => {
  const base64 = await fileToBase64(file)

  return {
    data: `data:${file.type};base64,${base64}`,
    filename: file.name
  }
}

export default buildActiveStorageFilePayload
